var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkerDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_91601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.85714C13.8971 9.85714 15.4171 8.32571 15.4171 6.42857C15.4171 4.53143 13.8971 3 12 3C10.1029 3 8.57143 4.53143 8.57143 6.42857C8.57143 8.32571 10.1029 9.85714 12 9.85714ZM12 12.1429C9.33714 12.1429 4 13.48 4 16.1429V19H20V16.1429C20 13.48 14.6629 12.1429 12 12.1429Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_91601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkerDay);
export default __webpack_public_path__ + "static/media/icon-worker-day.2ba4cf9f81ac9693a7d68c5046cc4271.svg";
export { ForwardRef as ReactComponent };